import { connect } from 'react-redux';
import {
  getFilterOptions,
  getNumberFuturePtos,
  resetFilters,
  setFilterDrawerOpen,
  setFilters,
} from '../../store/openOrder';

import ViewFilterDrawer from './ViewFilterDrawer';

const mapStateToProps = state => ({
  filterOptions: getFilterOptions(state),
  filters: state.pto.openPtos.filters,
  numberFuturePtos: getNumberFuturePtos(state),
  openPtoList: state.pto.openPtos.openPtoList,
});

const mapDispatchToProps = {
  resetFilters,
  setFilterDrawerOpen,
  setFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewFilterDrawer);
